module.exports = __webpack_public_path__ + "img/informes.5de838df.jpeg";